import { FaEyeSlash } from "react-icons/fa6";
import { RowSharedContent, formatAge, styles, type SharedProps } from "./_ItemRowShared.js";

export function ItemRowDesktop({ item, isRead, onRead, source, highlight }: SharedProps) {
  return (
    <div className={`${styles.row} ${isRead ? styles.read : ""} ${source ? styles.hasSource : ""}`}>
      <div className={styles.rowInner}>
        <RowSharedContent
          item={item}
          isRead={isRead}
          onRead={onRead}
          source={source}
          highlight={highlight}
          metaSlot={
            <div className={styles.meta}>
              <div style={{ display: "flex", gap: "4px", alignItems: "baseline" }}>
                {item.author && <span className={styles.author}>{item.author}</span>}
                <span className={styles.timeAgo}>{formatAge(item.publishedAt)}</span>
              </div>
            </div>
          }
        />
        <div className={styles.rowActions}>
          <button
            type="button"
            className={styles.rowBtn}
            onClick={() => onRead(item.id)}
            title="Hide"
          >
            <FaEyeSlash size={14} />
          </button>
        </div>
        <div className={styles.metaOverlay}>
          {item.author && <span className={styles.author}>{item.author} · </span>}
          <span className={styles.timeAgo}>{formatAge(item.publishedAt)}</span>
        </div>
      </div>
    </div>
  );
}
